import { Component } from "@angular/core";

@Component({
  selector: "app-test-home",
  template: ` <h2>This is test home!!</h2> `,
})
export class TestHomeComponents {}
